import { create } from 'zustand';
import { useEffect } from 'react';
import { api } from '@/lib/api';
import { useBoot } from './boot';

interface Contact { phone?: string; whatsapp?: string; email?: string }
interface Hours { start?: string; end?: string; days?: number[]; note?: string }
interface Cfg { contact: Contact; hours: Hours; legal: Record<string, string> }
const KEY = 'dd.support';
const load = (): Cfg => { try { return JSON.parse(localStorage.getItem(KEY) ?? '') as Cfg; } catch { return { contact: {}, hours: {}, legal: {} }; } };

export const useSupportCfg = create<{ cfg: Cfg; refresh: () => Promise<void> }>((set) => ({
  cfg: load(),
  async refresh() {
    try {
      const c = await api.get<Cfg>('/public/support/config', { auth: false });
      localStorage.setItem(KEY, JSON.stringify(c));
      set({ cfg: c });
    } catch { /* keep the cached copy */ }
  },
}));

export const DEFAULT_CONTACT: Contact = {
  phone: '+8801841044740',
  whatsapp: '+8801841044740',
  email: 'support@dokaandigit.com',
};

export function useSupportContact(): Contact {
  const boot = useBoot((s) => s.data?.config.support.contact);
  const cfg = useSupportCfg((s) => s.cfg.contact);
  const refresh = useSupportCfg((s) => s.refresh);
  useEffect(() => { void refresh(); }, [refresh]);
  return { ...DEFAULT_CONTACT, ...cfg, ...(boot ?? {}) };
}
export const useSupportHours = (): Hours => useSupportCfg((s) => s.cfg.hours);
export const useLegal = (): Record<string, string> => useSupportCfg((s) => s.cfg.legal);

const digits = (s?: string): string => (s ?? '').replace(/[^\d]/g, '');
export const waLink = (n?: string, text?: string): string => {
  const d = digits(n);
  const num = d.startsWith('0') ? `88${d}` : d;
  return `https://wa.me/${num}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
};
export const telLink = (n?: string): string => `tel:${(n ?? '').replace(/[^\d+]/g, '')}`;
